/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import { GtoUom } from '../../take-off-params';
import { HousePlanDetailsDto, HousePlanTopListDto, HousePlanTopListItemDto } from '../models/house-plan-details.dto';
import { HousePlanStyle } from '../models/house-plan-style.enum';

export const HousePlanDetailsMapper = entity<HousePlanDetailsDto>({
  style: enumeration(HousePlanStyle),
});

export const HousePlanGetTopsRequestMapper = entity<HousePlanTopListDto>({
  takeOffParams: arrayOf(subentity<HousePlanTopListItemDto>({
    uomCode: enumeration(GtoUom),
  })),
});
